
export const SingleButtons = [
  { id: 1, class: 'primary' },
  { id: 2, class: 'secondary' },
  { id: 3, class: 'success' },
  { id: 4, class: 'info' },
  { id: 5, class: 'warning' },
  { id: 6, class: 'danger' }
];

export const OutlineButtons = [
  { id: 1, class: 'outline-primary' },
  { id: 2, class: 'outline-secondary' },
  { id: 3, class: 'outline-success' },
  { id: 4, class: 'outline-info' },
  { id: 5, class: 'outline-warning' },
  { id: 6, class: 'outline-danger' }
];

export const SplitButtonsdata = [
  { id: 1, class: 'primary' },
  { id: 2, class: 'secondary' },
  { id: 3, class: 'info' },
  { id: 4, class: 'success' },
  { id: 5, class: 'warning' },
  { id: 6, class: 'danger' }
];


export const SizingButtons = [
  { id: 1, class: 'primary', size: 'lg', text1: 'Large button', text2: 'Large split button' },
  { id: 2, class: 'primary', size: 'sm', text1: 'Small  button', text2: 'Small split button' },
];

export const AutocloseButtons = [
  { id: 1, class: 'primary', text: 'Default dropdown' },
  { id: 2, class: 'secondary', text: 'Clickable  outside' },
  { id: 3, class: 'info', text: 'Clickable  inside' },
  { id: 4, class: 'warning', text: 'Manual  close' },
];


export const CustomButtons = [
  { id: 1, class: 'primary', text: 'Primary', class1: 'menu-primary', class2: '' },
  { id: 2, class: 'secondary', text: 'Secondary', class1: 'menu-secondary', class2: '' },
  { id: 3, class: 'warning', text: 'warning', class2: '', class1: 'menu-warning' },
  { id: 4, class: 'info', text: 'info', class2: '', class1: 'menu-info' },
  { id: 5, class: 'success', text: 'success', class2: '', class1: 'menu-success' },
  { id: 6, class: 'danger', text: 'danger', class2: '', class1: 'menu-danger' }
];


export const GhostButtons = [
  { id: 1, class: 'primary-ghost', text: 'Primary' },
  { id: 2, class: 'secondary-ghost', text: 'Secondary' },
  { id: 3, class: 'warning-ghost', text: 'warning' },
  { id: 4, class: 'info-ghost', text: 'info' },
  { id: 5, class: 'success-ghost', text: 'success' },
  { id: 6, class: 'danger-ghost', text: 'danger' }
];

export const AlignmentButtons = [
  { id: 1, class: 'primary', text: 'Dropdown', dir: '' },
  { id: 2, class: 'secondary', text: 'Right-aligned menu', dir: '' },
  { id: 3, class: 'info', text: 'Left-aligned, right-aligned lg', dir: '' },
  { id: 4, class: 'warning', text: 'Right-aligned, left-aligned lg', dir: '' },
  { id: 5, class: 'success', text: 'Dropstart', dir: 'start' },
  { id: 6, class: 'danger', text: 'Dropend', dir: 'end' },
  { id: 7, class: 'teal', text: 'Dropup', dir: 'up' }
];
